import styled from 'styled-components'

export const CardBanner = styled.img<{
    height?: string
    src?: string
}>`
    display: ${({ src }) => (src ? 'block' : 'none')};
    width: 100%;
    height: ${({ height }) => (height ? height : '30%')};
    object-fit: cover;
`
